<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import IconLabel from '$lib/components/atoms/iconlabel/IconLabel.svelte';
	/*
	component is a workaround to provide multiple icons close together for michelin filter
	it uses negative margin on the icons to move them closer and a margin to create a single gap between text and icons
	otherwise it is a reduced version of Chip
	It should not be used in other files and will be replaced by a new Scale component later.
	*/
	interface Props {
		text?: string;
		selected?: boolean;
		icon?: IconName;
		iconAmount?: number;
		onSelectedChange: (selectedChange: boolean) => void;
	}

	let {
		text,
		selected = $bindable(false),
		icon,
		iconAmount,
		onSelectedChange,
	}: Props = $props();

	const classes = $derived(selected ? 'bg-coloredneutral text-neutral-weakest' : 'bg-neutral-soft  hover:bg-coloredneutral-weak text-coloredneutral');
</script>

<button
	type="button"
	role="option"
	aria-selected={selected}
	class={['whitespace-nowrap flex justify-center items-center text-md rd-full p-2 gap-0 b-0 cursor-pointer', classes]}
	onclick={() => {
		selected = !selected;
		onSelectedChange?.(selected);
	}}
>
	<IconLabel
		{icon}
		amountOfRepeatedIcons={iconAmount}
		label={text}
		labelClasses="ml-1.75"
		iconClasses="mr--0.75"
		tag="span"
		iconTag="span"
	/>
</button>
